import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Button, Row, Col, Tooltip } from 'reactstrap';
import TextAreaComponent from '../../Home/list/components/TextAreaComponent';
import { Info } from 'react-feather';
import { Rate } from 'antd';
import Select from '../../../components/Select/Select';
import '../projects.scss';

function ResourceRemarksComponent(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  // -------- destructuring --------------
  const {
    empName,
    isPmCsmSales,
    deleteModalFlag,
    setDeleteModalFlag,
    selectInputRefss,
    selectTechnologyHandler,
    skills,
    communication,
    setCommunication,
    workQuality,
    setWorkQuality,
    reasonDetachmentOptions,
    setReasonOfDetachment,
    handleDelLim,
    handleReason,
    rating,
    setRating,
    emptyStates,
    canDeleteResource,
    deleteLim,
    deleteProject,
    empToDeleteId,
    projToDeleteId,
    isDeleteLoading,
    replaceWithComponent = undefined,
    resetReplaceWithComponenet = undefined,
  } = props;
  const allowDeleteResource = () => {
    return canDeleteResource && !deleteLim;
  };
  const list = ['Very Unsatisfied', 'Unsatisfied', '  Average', 'Satisfactory', 'Very Satisfactory'];
  return (
    <>
      <Modal
        isOpen={deleteModalFlag}
        toggle={() => setDeleteModalFlag(!deleteModalFlag)}
        centered={true}
        backdrop={(true, 'static')}
        onOpened={() => {
          document.body.style.overflow = 'hidden';
        }}
        onClosed={() => {
          document.body.style.overflow = 'auto';
          resetReplaceWithComponenet && resetReplaceWithComponenet();
        }}
        onExit={() => {
          document.body.style.overflow = 'auto';
          resetReplaceWithComponenet && resetReplaceWithComponenet();
          emptyStates();
        }}
      >
        <ModalHeader toggle={() => setDeleteModalFlag(!deleteModalFlag)}>{`Are you sure you want to ${replaceWithComponent ? 'replace' : 'remove'} ${
          empName || ''
        }?`}</ModalHeader>
        <ModalBody>
          <Form>
            {replaceWithComponent ? (
              <p style={{ fontSize: '11px', fontWeight: 'bold' }}>
                <span style={{ color: 'red' }}>Note:</span> You are replacing a resource after a week. Please fillout the R3 report
              </p>
            ) : (
              <p style={{ fontSize: '11px', fontWeight: 'bold' }}>
                <span style={{ color: 'red' }}>Note:</span> You are removing a resource after a week. Please fillout the R3 report
              </p>
            )}
            <FormGroup>
              {replaceWithComponent && (
                <Label className="modalLabel" for="rName">
                  <b>Replace With</b>
                  <span className="text-danger">*</span>
                </Label>
              )}
              {replaceWithComponent && replaceWithComponent()}
            </FormGroup>
            <FormGroup>
              <Label id="demo-simple-select-label">
                {isPmCsmSales ? <b>Skills</b> : <b>Technology</b>}
                <span className="text-danger">*</span>
              </Label>
              <div style={{ marginBottom: '-10px' }}>
                <Select
                  ref={selectInputRefss}
                  name="technology"
                  placeholder={isPmCsmSales ? 'Skills' : 'Technology'}
                  onChange={selectTechnologyHandler}
                  options={skills}
                  isClearable={true}
                  isMulti={true}
                />
              </div>
            </FormGroup>
            <FormGroup>
              <Label className="modalLabel" for="dName">
                <b>Reason Of Detachment</b>
                <span className="text-danger">*</span>
              </Label>
              <Select placeholder="Reason Of Detachment" options={reasonDetachmentOptions} onChange={(e) => setReasonOfDetachment(e)} />
            </FormGroup>
            <Row className="rowCommunication">
              <Col sm="6" className="d-flex align-items-center">
                <Label className="modalLabel mb-0">
                  <b>Communication</b>
                  <span style={{ color: 'red' }}>*</span>
                </Label>
              </Col>
              <Col sm="6" style={{}}>
                <FormGroup className="mb-0 d-flex justify-content-end align-items-center h-100">
                  <Rate
                    style={{ marginBottom: '-1px' }}
                    className="formGroupRate"
                    tooltips={list}
                    count={5}
                    value={communication}
                    onChange={setCommunication}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="rowQuality">
              <Col sm="6" className="d-flex align-items-center">
                <Label className="modalLabel mb-0">
                  <b>Work Quality</b>
                  <span style={{ color: 'red' }}>*</span>
                </Label>
              </Col>
              <Col sm="6" style={{ marginTop: 2 }}>
                <FormGroup className="mb-0 d-flex justify-content-end align-items-center h-100">
                  <Rate
                    style={{ marginBottom: '-1px' }}
                    className="formGroupRate"
                    tooltips={list}
                    count={5}
                    value={workQuality}
                    onChange={setWorkQuality}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className={'rowQuality'}>
              <Col sm="6" className="d-flex align-items-center">
                <Label className="modalLabel mb-0">
                  <b>Overall Rating</b>
                  <span style={{ color: 'red' }}>*</span>
                </Label>
              </Col>
              <Col sm="6" style={{ marginTop: 2 }}>
                <FormGroup className="mb-0 d-flex justify-content-end align-items-center h-100">
                  <Rate style={{ marginBottom: '-1px' }} className="formGroupRate" count={5} value={rating} onChange={setRating} />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup style={{ marginTop: 10 }}>
              <Label className="mb-0">
                <b>Overall Remarks</b>
                <span className="text-danger">*</span>
                <Tooltip placement="right" isOpen={tooltipOpen} target="overallRemarks" toggle={toggleTooltip}>
                  Add Overall Remarks of Resource
                </Tooltip>
                <Info id="overallRemarks" size={16} />
              </Label>
              <TextAreaComponent handleDelLim={handleDelLim} handleReason={handleReason} characters={300} />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              setDeleteModalFlag(false);
              emptyStates();
              resetReplaceWithComponenet && resetReplaceWithComponenet();
            }}
          >
            Close
          </Button>
          <Button
            disabled={!allowDeleteResource() || isDeleteLoading}
            color="primary"
            onClick={() => {
              deleteProject(empToDeleteId, projToDeleteId);
            }}
          >
            {replaceWithComponent ? 'Replace' : 'Delete'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ResourceRemarksComponent;
